module.exports = __webpack_public_path__ + "media/images/weather/51_day_g-b19b36a32d564d63ceab72f9ed8bb749.png";